module.exports = __webpack_public_path__ + "img/1564040838940.37a9bfb6.jpeg";